// import { Dimensions } from 'react-native'

// Universal
const MILLIS_IN_ONE_SECOND = 1000
const SECONDS_IN_MINUTE = 60
const MINUTES_IN_HOUR = 60

const HOURS_IN_DAYS = 24

const POLLING_INTERVAL_TIME = 2000; // 2 seconds
const screenWidth = window.innerWidth
const screenHeight = window.innerHeight

const USER_TOKEN = 'token'
const JOINED_TOURNAMENTS = 'joinedTounaments'
const SOUND_CONFIG = 'soundArr'
const SOUND_STATUS = 'soundStatus'
const MUSIC_STATUS = 'musicStatus'
const SERIAL_NUMBER_STORE_KEY = 'serialNumber'
const DEFAULT_REQUEST_TIMEOUT = 20000
const SPLASH_SCREEN_TIMEOUT = 3500
const APPLE_DISCLAIMER_MESSAGE_TIME = 10000
const ON = 'on'
const OFF = 'off'
const APPSTORE_URL = 'https://apps.apple.com/in/app/zupee-ludo-supreme/id1576310504'
const APP_ID = '1576310504'
const PARTNER_ID = 'PWA'
const FACEBOOK = "Facebook";  
// On Boarding
const ON_BOARDING_STEPS = {
  DASHBOARD: 'DASHBOARD',
  REFERRAL: 'REFERRAL',
  BONUS_ANIMATION: 'BONUS_ANIMATION'
  // 'INFO_GRAPHIC',
  // 'FREE_TO_GOLD',
  // 'VIDEO',
  // 'WALKTHROUGH',
  // 'TOURNAMENT_LOBBY',
}

// Home Page
const LAST_REQUEST_HOME_PAGE_V3 = 'lastRequest'
const HOME_PAGE_WIDGETS_RESPONSE = 'homePageWidgetsResponse'
const DEFAULT_CACHE_INTERVEL = 30
const GAME_LIST = 'gameList'
const UN_LOCKED_GAME_LIST = 'unlockedGamesList'
const LOCKED_GAME_REASON = {
  BANNED_STATE: 'BANNED_STATE',
  UNDER_MAINTENANCE: 'UNDER_MAINTENANCE',
  NEW_USER: 'NEW_USER',
  NONE: 'NONE'
}
const FOUND_STATE = '%found_state%'
const GAME_NAME = '%game_name%'
const BANNED_STATE = '%banned_states%'
const BANNED_GAMES = '%banned_games%'
const WHEN_IN_USE = 'whenInUse'

const QUICK_PAY = 'quickPay'

// Adjust constants
const USER_NAME = 'un'
const USER_ID = 'uid'
const APP_VERSION = 'app_version'
const USER_LOGIN_TYPE = 'ult'
const PACKAGE_NAME = 'packageName'
const SERIAL_NUMBER = 'SerialNumber'
const WINNING_AMOUNT = 'winning_amount_available'
const BONUS_AMOUNT = 'bonus_amount_available'
const REQUESTED_AMOUNT = 'requested_amount'
const MODE = 'mode'
const TOPUP_AMOUNT = 'top_up_amount'
const DATE = 'date'
const ORDER_ID = 'order_id'
const COUPON_ID = 'coupon_id'
const INITIATED_FROM = 'initiated_from'
const TOURNAMENT_ID = 'tournament_id'
const ENTRY_FEE = 'entry_fee'
const TOURNAMENT_TYPE = 'type'
const TOURNAMENT_START_TIME = 'start_time'
const TOURNAMENT_REG_TIME = 'reg_time'
const TOURNAMENT_REG_COUNT = 'reg_count'
const PRIZE_POT = 'prize_pot'
const DISTRIBUTION = 'distribution'
const TYPE = 't'
const RESET = 'reset'
const STATE = 'state'
const CODE_USED = 'code_used'
const PREV_FILTERS = 'prevAppliedFilters'
const NEW_FILTERS = 'newAppliedFilters'
const IS_REFERRAL_BANNER_REMOVED = 'isReferralBannerRemoved'

const LOBBY_HEADER = 'Lobby header'
const PROFILE = 'Profile'
const DASHBOARD = 'Dashboard'
const PWF = 'pwf'
const TOURNAMENT_LOBBY = 'tournament_lobby'
const LANGUAGE = 'language'
const LOGIN_SUCCESS_EVENT = 'login_sp_event_success'
const EXTERNAL_TIMESTAMP_URL = 'external_timestamp_url'
const DEVICE_IDENTIFIER_RECEIVED = 'device_identifier_received'
const NAVIGATOR_LOADED = 'navigatorLoaded'
const TICKET_CREATED = "ticket-created"
const YMChatEvent = "YMChatEvent"
const DGP_GAME_JOINED_START_TIME = "DGPGamejoinedStartTime"

//BOTTOMSHEET TYPES
const WITHDRAW_SCREEN = 'withdraw screen'
const RESPONSIBLE_GAMING = 'RESPONSIBLE_GAMING'
const SUBMIT_KYC = 'submit kyc'
const RUPEES_SYMBOL = '₹'
const DIALING_CODE = '+91'
const FILTER_BOTTOMSHEET = 'lobby filter'
const CONFIRM_PAYMENT_BOTTOMSHEET = 'confirm payment bottomsheet'
const WAIT_FOR_MATCH_BOTTOMSHEET = 'wait for match bottomsheet'
const SIGN_IN_ACTION = 'SignIn'
const SIGN_UP_ACTION = 'SignUp'
const MAIN_CLIENT = 'MAIN_CLIENT'
const LOGIN_TYPES = {
  PHONE: 'phone',
  APPLE: 'apple',
  GOOGLE: 'google'
}

const SIGN_IN_CODES = {
  SUCCESS_CODE: '0000',
  INCORRECT_OTP: '2005',
  INVALID_REFRESH_TOKEN: '1005',
  SKIP_AUTHENTICATION_FAILED: '2007',
  EXISTING_USER_ERROR_CODE: '1013'
}
const KYC_DELINK = 'KYC_DELINK'
const KYC_NUDGE = 'TDS_KYC'

const GLOBAL_SOCKET_EVENTS = {
  CONNECTION_MANAGE: 'CONNECTION_MANAGE',
  TOURNAMENT_STARTED: 'TOURNAMENT_STARTED',
  GAME_STARTED: 'GAME_STARTED',
  GET_USER_DETAILS: 'GET_USER_DETAILS',
  NRD: 'NRD',
  NRC: 'NRC',
  SP: 'SP',
  TOURNAMENT_JOIN_STATUS: 'TOURNAMENT_JOIN_STATUS',
  TOURNAMENT_STARTING: 'TOURNAMENT_STARTING',
  REGISTRATION_COUNT: 'REGISTRATION_COUNT',
  GENERIC_POPUP: 'GENERIC_POPUP',
  MT_TOURNAMENT_STARTING: 'MT_TOURNAMENT_STARTING',
  MT_TOURNAMENT_STARTED: 'MT_TOURNAMENT_STARTED',
  MTT_GAME_STARTED: 'MTT_GAME_STARTED',
  MT_TOURNAMENT_JOIN_STATUS: 'MT_TOURNAMENT_JOIN_STATUS',
  MTT_TIMER_STARTED: 'MTT_TIMER_STARTED',
  MTT_SUSPENDED: 'MTT_SUSPENDED',
  WD: 'WD',
  MTT_REGISTRATION_COUNT: 'MTT_REGISTRATION_COUNT',
  NUDGE_INDICATOR: 'NUDGE_INDICATOR',
  NNTF: 'NNTF',
  USER_RG_STATUS_UPDATE: 'USER_RG_STATUS_UPDATE',
  UPDATE_REFERRAL_CARDS: 'UPDATE_REFERRAL_CARDS',
  VIP_INDICATOR_EVENT:'VIP_INDICATOR_EVENT'
}

// Tournament Registration States
const TOURNAMENT_JOIN_SOO = 'SKIPPED_ON_OFFLINE'
const TOURNAMENT_JOIN_PODT = 'PLAYING_ON_DIFFERENT_TABLE'
const TOURNAMENT_JOIN_TA = 'TABLE_ASSIGNED'
const TOURNAMENT_JOIN_TJ = 'TABLE_JOINED'
const TOURNAMENT_JOIN_TSJ = 'TABLE_SYSTEM_JOINED'
const TOURNAMENT_JOIN_TNA = 'TABLE_NOT_ASSIGNED'
const TOURNAMENT_JOIN_R = 'REGISTERED'
const TOURNAMENT_JOIN_UR = 'UNREGISTERED'
const TOURNAMENT_JOIN_TL = 'TABLE_LEFT'

const TOURNAMENT_SUCCESS_STATES = [TOURNAMENT_JOIN_TA, TOURNAMENT_JOIN_TJ, TOURNAMENT_JOIN_TSJ]
const TOURNAMENT_FAILURE_STATES = [TOURNAMENT_JOIN_SOO, TOURNAMENT_JOIN_PODT, TOURNAMENT_JOIN_TNA, TOURNAMENT_JOIN_TL]

const RJT = 'RJT'
const JOIN_MT_TOURNAMENT_TABLE = 'JOIN_MT_TOURNAMENT_TABLE'
const JOIN_TOURNAMENT_TABLE = 'JOIN_TOURNAMENT_TABLE'
const DEVICE_ID_MAX_FETCH_TIME = 5000
const MAX_ADJUST_ID_RETRY_COUNT = 5

const SOCKET_ERROR_TYPES = {
  TIME_OUT: 'TIME_OUT',
  ERROR: 'ERROR',
  CONNECT_ERROR: 'CONNECT_ERROR'
}
const SOCKET_CLIENT_DISCONNECT_REASON = 'io client disconnect'
const SOCKET_SERVER_DISCONNECT_REASON = 'io server disconnect'
const UPDATE_REGISTRTION_COUNT_INVERVAL = 200
const TIME_OUT_ERROR = 'ECONNABORTED'
const CARD_DELETE_TIME_OUT = 5000
const API_REQUEST_TIME_OUT = 30000
const RETRY_AFTER_DELAY = 5000
const MAX_NUMBER_OF_API_RETRY = 3

const APP_STATE_ACTIVE = 'active'
const APP_STATE_INACTIVE = 'inactive'
const APP_STATE_BACKGROUND = 'background'
const APP_ACTIVITY_EVENTS = 'APP_ACTIVITY_EVENTS'
const APP_IN_FOREGROUND = 'APP_IN_FOREGROUND'
const APP_IN_BACKGROUND = 'APP_IN_BACKGROUND'
const GAME_RELATED = 'GAME_RELATED'
const COLLUSION_ONBOARDING_COMPLETED = 'COLLUSION_ONBOARDING_COMPLETED'
const HIDE_DICE_HAND_ANIMATION = 'HIDE_DICE_HAND_ANIMATION'
const HIDE_DICE_HAND_ANIMATION2P = 'HIDE_DICE_HAND_ANIMATION2P'
const SCREEN_LIST = 'SCREEN_LIST'
const YES= 'YES'
const MAIN_SOCKET = 'MAIN_SOCKET'
const THREEP_SOCKET = '3P_SOCKET'
const CONNECTED = 'connected'
const DISCONNECTED = 'disconnected'
const SOCKET_INFO = 'SOCKET_INFO'

const TOKEN_CUT_CN_COUNT_FOR_CURRENT_GAME = 'cnTCutCountForCurrentGame'
const REACH_HOME_CN_COUNT_FOR_CURRENT_GAME = 'cnRHCountForCurrentGame'
const SAFE_CN_COUNT_FOR_CURRENT_GAME = 'cnSCountForCurrentGame'

const APP_ACTIVITY_EVENTS_STATE = {
  [APP_STATE_ACTIVE]: APP_IN_FOREGROUND,
  [APP_STATE_BACKGROUND]: APP_IN_BACKGROUND,
  UNITY_INITIALIZED: 'UNITY_INITIALIZED',
  UNITY_IN_BACKGROUND: 'UNITY_IN_BACKGROUND',
  UNITY_IN_FOREGROUND: 'UNITY_IN_FOREGROUND'
}

const TRIGGER_REQUEST_CTA_VALUE = {
  PROFILE_FOLLOW: 'follow',
  PROFILE_UNFOLLOW: 'unfollow',
  PROFILE_REMOVE: 'remove'
}

const THRESHOLD_LATENCY = 400
const CONNECTIVITY_SAMPLING_SIZE = 2

const ConnectivityState = {
  STABLE: 'STABLE', // connected & stable
  WEAK: 'WEAK', // connected but high latency
  UNSTABLE: 'UNSTABLE', // Fluctuating socket connectivity
  DISCONNECTED: 'DISCONNECTED' // disconnected
}

const FBSDK_EVENT_ID = {
  // SIGNUP: 'rrcpyu', // backend event
  // DEPOSIT_SUCCESS: 'jutp02', // backend event
  EVENT_FIRST_DEPOSIT: 'EVENT_FIRST_DEPOSIT', //'b04kf8'
  EVENT_SIGN_UP: 'EVENT_SIGN_UP' //'kqz9tk'
}

const REMOVE_AVATAR = 'REMOVE_AVATAR'

const SCREEN_BANNER_MAP = {
  WALLET: 'walletBanner',
  WITHDRAWAL: 'withdrawalBanner',
  HOMEPAGE: 'homepageBanner'
}

const PLAYERS_3 = 'PLAYERS_3'

const HELPDESK_TOPIC_IDS = {
  GAME_RELATED: 'GAME_RELATED',
  DEPOSITS_AND_WITHDRAWALS_RELATED: 'DEPOSITS_AND_WITHDRAWALS_RELATED',
  TDS_RELATED: 'TDS_RELATED',
  KYC: 'KYC',
  ACCOUNT_RELATED: 'ACCOUNT_RELATED',
  ACCOUNT_DELETION: 'ACCOUNT_DELETION'
}

const PRE_SIGNUP_VALID_PATHS = {
  SPLASH: 'SPLASH',
  LANGUAGE_CHANGE: 'LANGUAGE_CHANGE',
  INTERNAL_SERVICES: 'INTERNAL_SERVICES'
}


const DTGS = 'deviceToGameplaySocket'

const DTGS_EVENTS = {
  EMIT: 'emit',
  DESTROY: 'destroy'
}

const SCREEN_NAMES = {
  TOURNAMENT_LOBBY: 'TOURNAMENT_LOBBY',
	NX_GAME_HISTORY: 'NX_GAME_HISTORY',
  SIGNUP: 'SIGNUP',
  GAME_HISTORY: 'GAME_HISTORY',
  SETTINGS: 'SETTINGS',
}

export {
  MILLIS_IN_ONE_SECOND,
  SECONDS_IN_MINUTE,
  MINUTES_IN_HOUR,
  HOURS_IN_DAYS,
  ON,
  OFF,
  PWF,
  RJT,
  JOIN_MT_TOURNAMENT_TABLE,
  JOIN_TOURNAMENT_TABLE,
  MODE,
  DATE,
  TYPE,
  RESET,
  STATE,
  USER_ID,
  PROFILE,
  ORDER_ID,
  LANGUAGE,
  QUICK_PAY,
  USER_NAME,
  COUPON_ID,
  ENTRY_FEE,
  PRIZE_POT,
  CODE_USED,
  DASHBOARD,
  USER_TOKEN,
  KYC_NUDGE,
  SUBMIT_KYC,
  KYC_DELINK,
  LOGIN_TYPES,
  MAIN_CLIENT,
  screenWidth,
  APP_VERSION,
  NEW_FILTERS,
  screenHeight,
  DIALING_CODE,
  PREV_FILTERS,
  LOBBY_HEADER,
  SOUND_CONFIG,
  SOUND_STATUS,
  MUSIC_STATUS,
  PACKAGE_NAME,
  BONUS_AMOUNT,
  TOPUP_AMOUNT,
  DISTRIBUTION,
  APPSTORE_URL,
  RUPEES_SYMBOL,
  SERIAL_NUMBER,
  TIME_OUT_ERROR,
  TOURNAMENT_ID,
  SIGN_IN_CODES,
  WINNING_AMOUNT,
  INITIATED_FROM,
  FBSDK_EVENT_ID,
  SIGN_UP_ACTION,
  SIGN_IN_ACTION,
  WITHDRAW_SCREEN,
  USER_LOGIN_TYPE,
  TOURNAMENT_TYPE,
  TOURNAMENT_LOBBY,
  REQUESTED_AMOUNT,
  TOURNAMENT_JOIN_R,
  FILTER_BOTTOMSHEET,
  RESPONSIBLE_GAMING,
  TOURNAMENT_JOIN_TA,
  TOURNAMENT_JOIN_TJ,
  TOURNAMENT_JOIN_TL,
  RETRY_AFTER_DELAY,
  TOURNAMENT_JOIN_UR,
  JOINED_TOURNAMENTS,
  SOCKET_ERROR_TYPES,
  TOURNAMENT_REG_TIME,
  TOURNAMENT_JOIN_SOO,
  TOURNAMENT_JOIN_TSJ,
  TOURNAMENT_JOIN_TNA,
  TOURNAMENT_REG_COUNT,
  TOURNAMENT_JOIN_PODT,
  GLOBAL_SOCKET_EVENTS,
  API_REQUEST_TIME_OUT,
  SPLASH_SCREEN_TIMEOUT,
  TOURNAMENT_START_TIME,
  MAX_NUMBER_OF_API_RETRY,
  SERIAL_NUMBER_STORE_KEY,
  DEFAULT_REQUEST_TIMEOUT,
  TOURNAMENT_SUCCESS_STATES,
  TOURNAMENT_FAILURE_STATES,
  SOCKET_SERVER_DISCONNECT_REASON,
  SOCKET_CLIENT_DISCONNECT_REASON,
  WAIT_FOR_MATCH_BOTTOMSHEET,
  CONFIRM_PAYMENT_BOTTOMSHEET,
  APPLE_DISCLAIMER_MESSAGE_TIME,
  UPDATE_REGISTRTION_COUNT_INVERVAL,
  CARD_DELETE_TIME_OUT,
  APP_STATE_ACTIVE,
  APP_STATE_BACKGROUND,
  APP_ACTIVITY_EVENTS_STATE,
  APP_ACTIVITY_EVENTS,
  THRESHOLD_LATENCY,
  CONNECTIVITY_SAMPLING_SIZE,
  ConnectivityState,
  LOGIN_SUCCESS_EVENT,
  DEVICE_IDENTIFIER_RECEIVED,
  DEVICE_ID_MAX_FETCH_TIME,
  MAX_ADJUST_ID_RETRY_COUNT,
  APP_STATE_INACTIVE,
  SCREEN_BANNER_MAP,
  REMOVE_AVATAR,
  TRIGGER_REQUEST_CTA_VALUE,
  EXTERNAL_TIMESTAMP_URL,
  GAME_RELATED,
  LAST_REQUEST_HOME_PAGE_V3,
  HOME_PAGE_WIDGETS_RESPONSE,
  DEFAULT_CACHE_INTERVEL,
  GAME_LIST,
  UN_LOCKED_GAME_LIST,
  LOCKED_GAME_REASON,
  FOUND_STATE,
  GAME_NAME,
  BANNED_STATE,
  BANNED_GAMES,
  WHEN_IN_USE,
  COLLUSION_ONBOARDING_COMPLETED,
  PLAYERS_3,
  SCREEN_LIST,
  HIDE_DICE_HAND_ANIMATION,
  HIDE_DICE_HAND_ANIMATION2P,
  YES,
  NAVIGATOR_LOADED,
  TICKET_CREATED,
  YMChatEvent,
  DGP_GAME_JOINED_START_TIME,
  IS_REFERRAL_BANNER_REMOVED,
  MAIN_SOCKET,
  THREEP_SOCKET,
  CONNECTED,
  DISCONNECTED,
  SOCKET_INFO,
  APP_ID,
  ON_BOARDING_STEPS,
  HELPDESK_TOPIC_IDS,
  PRE_SIGNUP_VALID_PATHS,
  TOKEN_CUT_CN_COUNT_FOR_CURRENT_GAME,
  REACH_HOME_CN_COUNT_FOR_CURRENT_GAME,
  SAFE_CN_COUNT_FOR_CURRENT_GAME,
  DTGS,
  DTGS_EVENTS,
  POLLING_INTERVAL_TIME,
  PARTNER_ID,
  SCREEN_NAMES,
  FACEBOOK
}
